import UnitConverter from '../services/unit_converter'

export default class UserDetails {
  constructor(attribs) {
    this.attribs = attribs

    this.attribs.pointsComposition = this.attribs.pointsComposition || {}

    const pointsComposition = this.attribs.pointsComposition
    pointsComposition.existingKilometersCount = pointsComposition.exisitingKilometersCount
  }

  getRank(key) {
    return this.attribs.pointsComposition[key]
  }

  getDistanceRank(key, sourceUnit, targetUnit) {
    const value = this.attribs.pointsComposition[key]
    if (value != null) {
      if (targetUnit != null) {
        return UnitConverter.convert(value, sourceUnit, targetUnit).toFixed(1)
      } else {
        return value.toFixed(1)
      }
    } else {
      return null
    }
  }

  getLastStatsUpdateTime() {
    let time = this.attribs.lastStatsUpdateTime
    if (time != null && time.length > 0) {
      time = parseInt(time, 10)
      if (time > 0) {
        return time
      }
    }
    return null
  }
}
